import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent {
  @Input() name: string;
  @Input() size: 'inherit' | 'teeny' | 'tiny' | 'small' | 'regular' = 'inherit';
  @Input() variant: 'outlined' | 'round';

  get classnames() {
    const classnames = ['icon'];
    classnames.push(this.variant ? `material-symbols-outlined-${this.variant}` : 'material-symbols-outlined');
    classnames.push(`icon-${this.size}`);

    return classnames;
  }
}
